export default {
    setKey(state, payload) {
        state.key = payload;
    },
    setPage(state, payload) {
        state.page = payload;
    }
};
